import { render } from "./HorizontalListItem.vue?vue&type=template&id=6bbd66b8&scoped=true"
const script = {}

import "./HorizontalListItem.vue?vue&type=style&index=0&id=6bbd66b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbd66b8"]])

export default __exports__